import { useGSAP } from "@gsap/react";
import Button from "./Button";
import Checkbox from "./Checkbox";
import crypto from "crypto-js"; // Using crypto-js for client-side hashing
import Input from "./Input";
import gsap from "gsap";
import { useRef, useState } from "react";
import cmsMail from "@/lib/cmsMail"
import ButtonFill from "./ButtonFill";

const Form = ({ idChanger = '', isPopUp = false, trianglesColorClass = 'bg-beige', formInfo, formResponse }) => {
  const formRef = useRef(null);
  const textRef = useRef(null);
  const inputsRef = useRef(null);
  const radiosRef = useRef(null);
  const bottomTextRef = useRef(null);
  const buttonWrapperRef = useRef(null);

  const [isFormSuccess, setIsFormSuccess] = useState(false)
  
  const [isChecked, setIsChecked] = useState(false);
  const [projectType, setProjectType] = useState('');
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [email, setEmail] = useState('');

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useGSAP(() => {
    if (isPopUp) return;
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
      gsap.fromTo(textRef.current, { opacity: 0 }, { opacity: 1, duration: 0.6, scrollTrigger: { trigger: formRef.current, start: "top 80%" } });
      gsap.fromTo(inputsRef.current, { opacity: 0 }, { opacity: 1, delay: 0.3, duration: 0.6, scrollTrigger: { trigger: formRef.current, start: "top 80%" } });
      gsap.fromTo(radiosRef.current, { opacity: 0 }, { opacity: 1, delay: 0.5, duration: 0.6, scrollTrigger: { trigger: formRef.current, start: "top 80%" } });
      gsap.fromTo(bottomTextRef.current, { opacity: 0 }, { opacity: 1, delay: 0.7, duration: 0.6, scrollTrigger: { trigger: formRef.current, start: "top 80%" } });
      gsap.fromTo(buttonWrapperRef.current, { opacity: 0 }, { opacity: 1, delay: 0.7, duration: 0.6, scrollTrigger: { trigger: formRef.current, start: "top 80%" } });
    });
  });


const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitted(true);

  if (!isChecked || !name || !tel || !email || loading) return;

  setLoading(true);

  try {
    const timestamp = Date.now().toString();
    const signature = crypto.MD5("secret designic" + timestamp).toString();

    const payload = {
      name: name,
      phone: tel,
      email: email,
      work: projectType,
      sign: signature,
      timestamp: timestamp
    };

      // Pass the body inside the second argument (options)
      const res = await cmsMail(payload);

      // Since your cmsClient already parses the JSON, 'res' is ready to use
      console.log("Form successfully submitted:", res);

    if(typeof ym !== 'undefined'){
      ym(54681091, 'reachGoal', 'FORM_SUB_1');
    }

      setResponse(res);
      setIsFormSuccess(true);
      setName('');
      setTel('');
      setEmail('');
      setProjectType('');
      setIsChecked(false);
      setIsSubmitted(false);

    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
};

  const disabled = false;

  const handleToggle = (e) => {
    if (disabled) return;
    setIsChecked(e.target.checked);
  };


  const handleTelChange = (e) => {
    let value = e.target.value;

    value = value.replace(/(?!^\+)[^\d]/g, '');

    setTel(value);
  };

  return (
    <>
    {!isFormSuccess ? <form ref={formRef} onSubmit={handleSubmit} className={`pt-[2.4rem] md:flex md:w-full md:flex-col md:items-center  text-center md:col-span-5 lg:col-span-8 lg:col-start-3  xl:col-span-6 xl:col-start-4 ${isPopUp ? '' : 'md:pt-[4rem]'}`}>
      <p ref={textRef} className={` mb-[2.4rem] md:max-w-[34.4rem] lg:max-w-[36rem] xl:max-w-[57rem]  text-1 ${isPopUp ? '' : 'md:mb-[3.2rem]'}`}>
        {formInfo.title}
      </p>
      
      <div ref={inputsRef} className={`${isPopUp ? '' : 'md:gap-y-[2.4rem]'} grid grid-cols-1 md:grid-cols-2 md:w-full mb-[2.4rem] lg:mb-[4rem] gap-[1.6rem] md:gap-x-[7.5%] lg:gap-x-[13%] xl:gap-x-[18.12%] `}>
        <Input isSubmitted={isSubmitted}  name="name" value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder={formInfo.inputs[0].text} />
        <Input  minLength={7} maxLength={15} name="tel" isSubmitted={isSubmitted} value={tel} onChange={handleTelChange} type="tel" placeholder={formInfo.inputs[1].text} />
        <Input isSubmitted={isSubmitted}  name="email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder={formInfo.inputs[2].text} className="md:col-span-2" />
      </div>

      <div ref={radiosRef} className={`flex flex-col md:w-full   md:gap-x-[8%]  md:gap-y-[2rem] gap-[1.2rem] md:grid md:grid-cols-2 ${isPopUp ? 'lg:mb-[2rem]' : 'lg:mb-[4rem]  lg:gap-[2rem] lg:flex lg:flex-row lg:items-start lg:justify-between'}`}>

        {/* Added onChange and checked states to the radio buttons */}
        {formInfo.radiobtns.map((item, index) => (
          <label 
            key={index} 
            className="flex group items-start gap-[0.8rem] lg:gap-[1.2rem] cursor-pointer"
          >
            <input
              type="radio"
              id={`radio${index + 1}${idChanger}`}
              name="project-type"
              value={item.value}
              className="peer hidden"
              onChange={(e) => setProjectType(e.target.value)}
              checked={projectType === item.value}
            />
            <span className="flex items-center justify-center min-w-[1.8rem] h-[1.8rem] lg:min-w-[2.4rem] lg:h-[2.4rem] border-[1px] border-dusty-blue-20 group-hover:border-dusty-blue rounded-full relative duration-200 peer-checked:border-dusty-blue after:content-[''] after:w-[1.2rem] after:h-[1.2rem] lg:after:w-[1.6rem] lg:after:h-[1.6rem] after:rounded-full after:bg-transparent-anim peer-checked:after:bg-dusty-green-dark" />
            <span className="text-[1.6rem] text-left text-dark-blue text-1">
              {item.text}
            </span>
          </label>
        ))}
      </div>
      
      <label ref={bottomTextRef} className={`${isPopUp ? 'lg:mb-[4rem]' : ''} mr-auto items-start flex text-left mt-[1.2rem] md:gap-[1.6rem] py-[1.6rem] gap-[1.2rem] mb-[2rem] cursor-pointer group`}>
        <input 
          id={"consent" + idChanger}
          name="consent" 
          type="checkbox" 
          className="sr-only" 
          required 
          disabled={disabled}
          checked={isChecked}
          onChange={handleToggle}
        />
        <span className={`inline-flex items-center gap-2 select-none flex-shrink-0 ${disabled ? "opacity-50 cursor-not-allowed" : ""} `}>
          <span className={`relative w-[2rem] p-[0.2rem] h-[2rem] border rounded-[0.1rem] transition-all duration-300 flex items-center justify-center ${isChecked ? "border-dark-blue" : "group-hover:border-dark-blue border-dusty-blue-20"}`}>
            <span className={`bg-dusty-green-dark w-full h-full transition-opacity duration-200 ${isChecked ? 'opacity-100' : 'opacity-0'}`}></span>
          </span>
        </span>
        <span className="text-1 [&>a]:cursor-pointer [&>a]:underline [&>a]: [&>a]:hover:opacity-80 [&>a]:relative [&>a]:z-10 [&>a]:w-auto [&>a]:transition-opacity [&>a]:duration-30 text-[1.4rem] md:text-[1.6rem] xl:text-[2rem] select-none" dangerouslySetInnerHTML={{__html: formInfo.checkbox.text}}/>
      </label>

      <div ref={buttonWrapperRef} className="w-full flex items-center justify-center">
        {/* Pass disabled state to Button if loading so the user doesn't spam click */}
        <Button disabled={loading} onClick={() => setIsSubmitted(true)} ariaLabel="Оставить заявку" trianglesColorClass={trianglesColorClass} className="md:w-fit w-full" type="submit" isFullSized={true}>
          {formInfo.button_text}
          <svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
          </svg>
        </Button>
      </div>
    </form> : <div className={`${isPopUp ? 'mt-[2.4rem] md:mt-[3.2rem] lg:mt-[4rem]' : 'mt-[7.2rem] md:mt-[8.8rem] lg:mt-[14rem] mb-[4rem] md:mb-[5rem]'}  lg:mb-[8rem] flex flex-col items-center w-full md:col-span-5 lg:col-span-8 lg:col-start-3  xl:col-span-6 xl:col-start-4 text-center`}>
      <div className="flex max-w-[31.5rem] md:max-w-[46.8rem] xl:max-w-[62.2rem] flex-col items-center">
        <p className="heading-4 mb-[2.4rem] md:mb-[3.2rem] lg:mb-[4rem]">{formResponse?.success_text}</p>
        <ButtonFill onClick={()=>{setIsFormSuccess(false)}} className='max-w-fit text-nowrap'>{formResponse?.success_btn}</ButtonFill>
      </div>

      </div>}
    </>
    
  );
};

export default Form;